import React from 'react'
import { Row, Col, Button, Modal } from 'react-bootstrap'

export default function SettingsModal({
  show,
  notify,
  notifyError,
  handleClose,
  handleSetNotify
}) {

  return (
    <Modal size='lg' show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className='font-weight-light'>Notification Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notifyError && <div className="alert alert-danger mb-5">{notifyError}</div>}

        <Row>
          <Col>
            <Row className='mb-2'>
              <Col className='font-weight-bold'>
                Notifications
              </Col>
            </Row>
            <Row>
              <Col>
                Receive notifications for this conversation
              </Col>
            </Row>
          </Col>
          <Col>
            <div className="custom-control custom-switch">
              <input
                id="notify-switch"
                type="checkbox"
                checked={notify}
                onChange={() => handleSetNotify(!notify)}
                className="custom-control-input cursor-pointer"
              />
              <label className="custom-control-label text-muted cursor-pointer" for="notify-switch">All Notifications</label>
            </div>
          </Col>
        </Row>

        <br />

      </Modal.Body>
      <Modal.Footer>
        <Button className='px-4 mt-5' variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
